<template>
    <label v-if="value && value.change" class="mb-0 d-flex align-items-center">
        <input type="checkbox" :disabled="disabled" :checked="value.id === currentUser.id" :value="currentUser.id" @change="onChange" />
        <span v-if="value.id" class="ml-1 text-nowrap text-truncate" v-b-tooltip.hover="currentUser.name" style="max-width: 80px">{{
            currentUser.name
        }}</span>
    </label>
    <label v-else-if="value" class="mb-0 d-flex align-items-center">
        <input type="checkbox" :disabled="disabled" :checked="!!value.id" @click="onClickView" />
        <span v-if="value.id" class="ml-1 text-nowrap text-truncate" v-b-tooltip.hover="value.name" style="max-width: 80px">{{
            value.name || ''
        }}</span>
    </label>
</template>

<script>
export default {
    name: 'CommonCheckbox',
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        currentUser: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onChange(event) {
            const newValue = { ...this.value };
            if (event.target.checked) {
                newValue.id = this.currentUser.id;
            } else {
                newValue.id = null;
            }
            this.$emit('input', newValue);
            this.$emit('change', newValue);
        },
        onClickView() {
            const newValue = { ...this.value, id: null, change: true };
            this.$emit('input', newValue);
            this.$emit('click-view', newValue);
        }
    }
};
</script>

<style scoped>
label {
    cursor: pointer;
}
input[type='checkbox'] {
    cursor: pointer;
}
input[type='checkbox']:disabled {
    cursor: not-allowed;
}
</style>
